module.exports = __webpack_public_path__ + "static/img/44混凝土.9edc27c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/44混凝土.jpg
// module id = FJO3
// module chunks = 0